import { Home } from './pages/Home'

export default function App() {
  return <Home />
}
